// extracted by mini-css-extract-plugin
module.exports = {"root":"l_qV","wrapper":"l_qW","image":"l_qX f_cs f_cv f_cS","crop":"l_qY","round":"l_qZ","fixedHeight":"l_q0"};